<div class="dialog-title">{{title}} Sale's Gallery Close Date  </div>
<!-- <div class="dialog-title" *ngIf="formType == formTypeRequest.EDIT">Edit Assigned Discount</div> -->
<form [formGroup]="formGrp" >
    <div class="form-field"  fxFlexAlign="stretch">
      <div white-space  >
        <div >
            <div fxFlex="50" class="left">
                <mat-form-field>
                  <mat-label>Start Date</mat-label>
                  <input matInput [matDatepicker]="startDate" required formControlName="startDate" [min]="minDate" />
                  <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                  <mat-datepicker #startDate></mat-datepicker>
                  <mat-error>Start date is required</mat-error>
                </mat-form-field>
              </div>
        
              <div fxFlex="50">
                <mat-form-field>
                  <mat-label>End Date</mat-label>
                  <input matInput [matDatepicker]="EndDate" required formControlName="endDate"  [min]="minDate" />
                  <mat-datepicker-toggle matSuffix [for]="EndDate"></mat-datepicker-toggle>
                  <mat-datepicker #EndDate></mat-datepicker>
                  <mat-error>End date is required</mat-error>
                </mat-form-field>
              </div>
        </div>

        <div >
            <div fxFlex="50" class="left">
                <mat-form-field>
                  <mat-label>Start Date</mat-label>
                  <input matInput formControlName="startTime" type="time" required />
                  <mat-error>Start Time is required</mat-error>
                </mat-form-field>
              </div>
        
              <div fxFlex="50">
                <mat-form-field>
                  <mat-label>End Date</mat-label>
                  <input matInput formControlName="endTime"  type="time"  required  />
                  <mat-error>End Time is required</mat-error>
                </mat-form-field>
              </div>
        </div>

      </div>
    </div>

    <span class="example-list-section" >
        <mat-checkbox
        (click)="$event.stopPropagation()"  
        (change)="isCheck($event,initialTime)" >
        <div class="xsTitle-f" style="white-space: pre-line">Follow initial start time and end time</div>
        </mat-checkbox>
    </span>

    <div class="dialog-buttons">
      <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
      <button mat-button color="primary" (click)="onSubmit()">Assign</button>
    </div>

</form>